import React from 'react';
import { Link } from 'react-router-dom';
import { FiUser, FiX, FiTrash2, FiDownload, FiCheckCircle, FiCheckSquare } from 'react-icons/fi';
import api, { getDownloadBaseUrl } from '../services/api';
import DocumentosSection from './DocumentosSection';
import './TarefaDetalhesModal.css';

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR');
};


const historicoIsExclusao = (h) => ['andamento_excluido', 'documento_excluido', 'responsavel_removido'].includes(h.tipo);

const getStatusBadge = (status) => {
  const badges = {
    pendente: 'badge-secondary',
    em_andamento: 'badge-info',
    done_pending_approval: 'badge-warning',
    concluida: 'badge-success',
    atrasada: 'badge-danger',
    cancelada: 'badge-secondary'
  };
  return badges[status] || 'badge-secondary';
};

const getStatusLabel = (status) => {
  const labels = {
    pendente: 'Pendente',
    em_andamento: 'Em Andamento',
    done_pending_approval: 'Aguardando Aprovação',
    concluida: 'Concluída',
    atrasada: 'Atrasada',
    cancelada: 'Cancelada'
  };
  return labels[status] || status;
};

const STATUS_OPTIONS = [
  { value: 'pendente', label: 'Pendente' },
  { value: 'em_andamento', label: 'Em andamento' },
  { value: 'done_pending_approval', label: 'Aguardando aprovação' },
  { value: 'concluida', label: 'Concluída' },
  { value: 'atrasada', label: 'Atrasada' },
  { value: 'cancelada', label: 'Cancelada' }
];

const PRIORIDADE_OPTIONS = [
  { value: 'alta', label: 'Alta' },
  { value: 'media', label: 'Média' },
  { value: 'baixa', label: 'Baixa' }
];

const TarefaDetalhesModal = ({
  tarefa,
  onClose,
  documentos,
  comentarios,
  historico,
  responsaveis,
  usuarios,
  novoComentario,
  setNovoComentario,
  showAddResponsavelForm,
  setShowAddResponsavelForm,
  addResponsavelId,
  setAddResponsavelId,
  openBadgeDropdown,
  setOpenBadgeDropdown,
  onAdicionarResponsavel,
  onRemoverResponsavel,
  onExcluirAndamento,
  onAprovar,
  onMudarStatus,
  onMudarPrioridade,
  onMudarVencimento,
  onAdicionarComentario,
  onRefreshDetalhes,
  onDocumentAdded,
  hasPermission,
  user
}) => {
  if (!tarefa) return null;

  return (
    <div className="modal-overlay tarefa-modal-overlay" onClick={onClose}>
      <div className="modal-detalhes-tarefa" onClick={(e) => e.stopPropagation()}>
        <div className="modal-detalhes-header">
          <h2><FiCheckSquare className="titulo-icon" /> {tarefa.titulo}</h2>
          <button type="button" className="btn-close" onClick={onClose} aria-label="Fechar"><FiX /></button>
        </div>

        <div className="modal-detalhes-meta">
          <div className="detalhes-meta-linha detalhes-meta-linha-status">
            <div className="detalhes-meta-item">
              <span className="detalhes-label">Status</span>
              <div className="badge-dropdown-wrap">
                {hasPermission('task', 'edit') ? (
                  <>
                    <button
                      type="button"
                      className={`badge badge-clickable ${getStatusBadge(tarefa.status_efetivo || tarefa.status)}`}
                      onClick={() => setOpenBadgeDropdown(openBadgeDropdown === 'status' ? null : 'status')}
                      title="Clique para alterar"
                    >
                      {getStatusLabel(tarefa.status_efetivo || tarefa.status)}
                    </button>
                    {openBadgeDropdown === 'status' && (
                      <div className="badge-dropdown">
                        {STATUS_OPTIONS.map((opt) => (
                          <button
                            key={opt.value}
                            type="button"
                            className={`badge-dropdown-item ${opt.value === (tarefa.status_efetivo || tarefa.status) ? 'active' : ''}`}
                            onClick={() => onMudarStatus(tarefa.id, opt.value)}
                          >
                            {opt.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <span className={`badge ${getStatusBadge(tarefa.status_efetivo || tarefa.status)}`}>{getStatusLabel(tarefa.status_efetivo || tarefa.status)}</span>
                )}
              </div>
            </div>
            <div className="detalhes-meta-item">
              <span className="detalhes-label">Prioridade</span>
              <div className="badge-dropdown-wrap">
                {hasPermission('task', 'edit') ? (
                  <>
                    <button
                      type="button"
                      className={`badge badge-clickable badge-${tarefa.prioridade === 'alta' ? 'danger' : tarefa.prioridade === 'media' ? 'warning' : 'secondary'}`}
                      onClick={() => setOpenBadgeDropdown(openBadgeDropdown === 'prioridade' ? null : 'prioridade')}
                      title="Clique para alterar"
                    >
                      {tarefa.prioridade === 'alta' ? 'Alta' : tarefa.prioridade === 'media' ? 'Média' : 'Baixa'}
                    </button>
                    {openBadgeDropdown === 'prioridade' && (
                      <div className="badge-dropdown">
                        {PRIORIDADE_OPTIONS.map((opt) => (
                          <button
                            key={opt.value}
                            type="button"
                            className={`badge-dropdown-item ${opt.value === tarefa.prioridade ? 'active' : ''}`}
                            onClick={() => onMudarPrioridade(tarefa.id, opt.value)}
                          >
                            {opt.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <span className={`badge badge-${tarefa.prioridade === 'alta' ? 'danger' : tarefa.prioridade === 'media' ? 'warning' : 'secondary'}`}>{tarefa.prioridade === 'alta' ? 'Alta' : tarefa.prioridade === 'media' ? 'Média' : 'Baixa'}</span>
                )}
              </div>
            </div>
            <div className="detalhes-meta-item">
              <span className="detalhes-label">Vencimento</span>
              {hasPermission('task', 'edit') ? (
                <input
                  type="date"
                  value={tarefa.data_vencimento ? tarefa.data_vencimento.split('T')[0] : ''}
                  onChange={(e) => {
                    const val = e.target.value || null;
                    const current = tarefa.data_vencimento ? tarefa.data_vencimento.split('T')[0] : '';
                    if (val !== current) onMudarVencimento?.(tarefa.id, val);
                  }}
                  className="input-vencimento"
                />
              ) : (
                <span>{formatDate(tarefa.data_vencimento)}</span>
              )}
            </div>
          </div>

          <div className="detalhes-meta-linha detalhes-meta-condicionante">
            <span className="detalhes-label">{tarefa.processo_licenciamento_id ? 'Origem' : 'Condicionante'}</span>
            <div className="detalhes-condicionante-texto">
              {tarefa.processo_licenciamento_id ? (
                <Link to={`/processos-licenciamento/${tarefa.processo_licenciamento_id}`} className="link-detalhes">
                  Processo: {tarefa.processo_licenciamento_titulo}
                </Link>
              ) : tarefa.licenca_id ? (
                <Link to={`/licencas/${tarefa.licenca_id}/validar`} className="link-detalhes">
                  {tarefa.condicionante_descricao || '-'}
                </Link>
              ) : (
                <span>{tarefa.condicionante_descricao || '-'}</span>
              )}
            </div>
          </div>

          <div className="detalhes-meta-linha detalhes-meta-emp-lic">
            <div className="detalhes-meta-meio">
              <span className="detalhes-label">Empreendimento</span>
              {tarefa.empreendimento_nome ? (
                <Link to={`/empreendimentos/${tarefa.empreendimento_id}`} className="link-detalhes">{tarefa.empreendimento_nome}</Link>
              ) : (
                <span>-</span>
              )}
            </div>
            <div className="detalhes-meta-meio">
              <span className="detalhes-label">Licença</span>
              {tarefa.licenca_id ? (
                <Link to={`/licencas/${tarefa.licenca_id}/validar`} className="link-detalhes">
                  {tarefa.licenca_numero ? `${tarefa.licenca_tipo || ''} ${tarefa.licenca_numero}`.trim() : tarefa.licenca_tipo || '-'}
                </Link>
              ) : (
                <span>-</span>
              )}
            </div>
          </div>
        </div>

        {tarefa.descricao && (
          <div className="detalhes-section">
            <h3>Descrição</h3>
            <p className="detalhes-descricao">{tarefa.descricao}</p>
          </div>
        )}

        <div className="detalhes-section membros-section responsaveis-section">
          <h3><FiUser /> Responsáveis</h3>
          <div className="membros-trello">
            {responsaveis.length > 0 ? (
              responsaveis.map((r) => (
                <div
                  key={r.usuario_id}
                  className={`membro-avatar ${hasPermission('task', 'delegate') && tarefa.delegation_allowed ? 'membro-avatar-clickable' : ''}`}
                  title={hasPermission('task', 'delegate') && tarefa.delegation_allowed ? `Clique para remover ${r.usuario_nome}` : r.usuario_nome}
                  onClick={hasPermission('task', 'delegate') && tarefa.delegation_allowed ? () => onRemoverResponsavel(r.usuario_id) : undefined}
                  role={hasPermission('task', 'delegate') && tarefa.delegation_allowed ? 'button' : undefined}
                >
                  {(r.usuario_nome || '?').charAt(0).toUpperCase()}
                </div>
              ))
            ) : (
              <span className="membro-empty">Sem responsáveis</span>
            )}
            {hasPermission('task', 'delegate') && tarefa.delegation_allowed && (
              <>
                {!showAddResponsavelForm ? (
                  <button type="button" className="membro-add-btn" onClick={() => setShowAddResponsavelForm(true)} title="Adicionar responsável">+</button>
                ) : (
                  <form className="delegar-form-trello" onSubmit={(e) => { e.preventDefault(); onAdicionarResponsavel(e); }}>
                    <select
                      value={addResponsavelId}
                      onChange={(e) => setAddResponsavelId(e.target.value)}
                      required
                      className="delegar-select"
                    >
                      <option value="">Selecione o responsável...</option>
                      {usuarios.filter((u) => !responsaveis.some((r) => r.usuario_id === u.id)).map((usr) => (
                        <option key={usr.id} value={usr.id}>{usr.nome}</option>
                      ))}
                    </select>
                    <div className="delegar-actions">
                      <button type="submit" className="btn btn-sm btn-primary">Adicionar</button>
                      <button type="button" className="btn btn-sm btn-secondary" onClick={() => { setShowAddResponsavelForm(false); setAddResponsavelId(''); }}>Cancelar</button>
                    </div>
                  </form>
                )}
              </>
            )}
          </div>
        </div>

        {tarefa.status === 'done_pending_approval' && hasPermission('task', 'approve') && (
          <div className="detalhes-section">
            <button type="button" className="btn btn-success" onClick={() => onAprovar(tarefa)}>
              <FiCheckCircle /> Aprovar conclusão
            </button>
          </div>
        )}

        <div className="modal-detalhes-body">
          <section className="detalhes-section">
            <h3>Documentos vinculados</h3>
            <DocumentosSection
              tarefaId={tarefa.id}
              documentos={documentos}
              onRefresh={(id) => onRefreshDetalhes(id || tarefa.id)}
              onDocumentAdded={onDocumentAdded}
            />
          </section>

          <section className="detalhes-section">
            <h3>Andamentos</h3>
            <form onSubmit={onAdicionarComentario} className="comentario-form">
              <textarea
                value={novoComentario}
                onChange={(e) => setNovoComentario(e.target.value)}
                placeholder="Adicione um andamento..."
                rows="3"
              />
              <button type="submit" className="btn btn-sm btn-primary">Enviar</button>
            </form>
            <ul className="comentarios-list">
              {comentarios.map((c) => (
                <li key={c.id} className="comentario-item">
                  <div className="comentario-conteudo">{c.conteudo}</div>
                  <div className="comentario-meta">
                    <span>{c.usuario_nome}</span>
                    <span>{formatDate(c.criado_em)}</span>
                    {(user?.id === c.usuario_id || hasPermission('task', 'edit')) && (
                      <button
                        type="button"
                        className="btn-link btn-danger btn-icon"
                        onClick={() => onExcluirAndamento(c.id)}
                        title="Excluir andamento"
                      >
                        <FiTrash2 />
                      </button>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </section>

          <details className="detalhes-section historico-section">
            <summary>Histórico de alterações</summary>
            <ul className="historico-list">
              {historico.map((h, i) => (
                <li key={`${h.origem}-${h.id || i}`} className={`historico-item ${historicoIsExclusao(h) ? 'historico-item-exclusao' : 'historico-item-adicao'}`}>
                  <span className="historico-data">{formatDate(h.criado_em)}</span>
                  <span className="historico-descricao">{h.descricao || h.conteudo || '-'}</span>
                  {((h.tipo === 'documento_adicionado' || h.tipo === 'documento' || h.tipo === 'documento_excluido') && h.arquivo) && (
                    <a href={`${getDownloadBaseUrl()}${h.arquivo}`} target="_blank" rel="noopener noreferrer" className="historico-link-download">
                      <FiDownload /> Baixar
                    </a>
                  )}
                  {h.conteudo && (h.tipo === 'andamento' || h.tipo === 'andamento_adicionado' || h.tipo === 'andamento_excluido') && (
                    <span className="historico-conteudo">{h.conteudo}</span>
                  )}
                  {h.usuario_nome && <span className="historico-usuario">{h.usuario_nome}</span>}
                </li>
              ))}
            </ul>
          </details>
        </div>
      </div>
    </div>
  );
};

export default TarefaDetalhesModal;
